import React from 'react';
import { Platform } from 'react-native';
import queryString from 'query-string';
import { get } from 'lodash';
import SideBarLayout from './SideBarLayout';
import { processStyles } from '../util.style';
import SideBarConfig from './config';
import {
  getComponentScreenDimensions,
  getScreenTypeFromId,
} from '../../../utils/responsive';
import { SidebarNavigationProps, SideBarBindingValue } from './types';
import { parseDimension } from '../util.style';
import { getActions, getValueBinding } from '../../shared';

export default function SidebarNavigation(props: SidebarNavigationProps) {
  const isCanvas =
    Platform.OS === 'web' &&
    !queryString.parse(window?.location?.search)?.target;

  const bindingValue = getValueBinding(
    props.id,
    props.data,
    props
  ) as SideBarBindingValue;

  const handleMenuItemPress = (item: any) => {
    if (isCanvas) return;

    if (item.action && props.onPress) {
      const actionProps = {
        ...props,
        attributes: {
          ...props.attributes,
          action: item.action,
        },
      };
      const actionData = getActions(actionProps, 'action');
      props.onPress(actionData, {});
    } else if (props.onMenuItemPress) {
      props.onMenuItemPress(item);
    }
  };
  if (isCanvas) {
    const {
      attributes,
      style,
      libraryComponentManifest,
      id,
      width,
      height,
      ...otherProps
    } = props;

    const screenType = getScreenTypeFromId(id);
    const breakpointIndex = id?.endsWith('.0') ? 0 : id?.endsWith('.1') ? 1 : 2;
    const screenDimensions = getComponentScreenDimensions(
      SideBarConfig,
      breakpointIndex
    );

    const { finalStyle } = processStyles({
      attributes,
      style,
      config: SideBarConfig,
      libraryComponentManifest,
      id,
      ...otherProps,
    });

    const effectiveWidth = parseDimension(width || screenDimensions.width);
    let heightValue = finalStyle.height || height || screenDimensions.height;
    if (
      typeof heightValue === 'string' &&
      heightValue.includes('%') &&
      height &&
      typeof height === 'number'
    ) {
      heightValue = height;
    }
    const effectiveHeight = parseDimension(heightValue);
    const containerStyle = {
      backgroundColor: finalStyle.backgroundColor || '#2c3e50',
      width: effectiveWidth,
      height: effectiveHeight,
      zIndex: finalStyle.zIndex || 1000,
    };

    // Destructure conflicting props from otherProps for canvas mode
    const {
      backgroundColor: _bg2,
      textColor: _tc2,
      activeColor: _ac2,
      hoverColor: _hc2,
      activeOpacity: _ao2,
      layoutMode: _lm2,
      collapsible: _c2,
      collapsed: _col2,
      position: _p2,
      showLogo: _sl2,
      logoPosition: _lp2,
      showUserProfile: _sup2,
      userProfilePosition: _upp2,
      attributes: _attr2,
      containerStyle: _cs2,
      isCanvasMode: _icm2,
      screenType: _st2,
      screenSize: _ss2,
      width: _w2,
      height: _h2,
      userName: _un2,
      ...canvasRestProps
    } = otherProps;

    return (
      <SideBarLayout
        userName={'User Name'}
        userEmail={'mail@sample.com'}
        containerStyle={containerStyle}
        screenType={screenType}
        screenSize={{ width: effectiveWidth, height: effectiveHeight }}
        width={effectiveWidth}
        height={effectiveHeight}
        isCanvasMode={true}
        attributes={attributes || {}}
        backgroundColor={finalStyle.backgroundColor || '#2c3e50'}
        textColor={finalStyle.color || '#ffffff'}
        activeColor={finalStyle.activeColor || '#3498db'}
        hoverColor={finalStyle.hoverColor || '#34495e'}
        activeOpacity={finalStyle.activeOpacity || 0.3}
        layoutMode={finalStyle.layoutMode || 'push'}
        collapsible={finalStyle.collapsible !== false}
        collapsed={finalStyle.collapsed || false}
        position={finalStyle.position || 'left'}
        showLogo={finalStyle.showLogo !== false}
        logoPosition={finalStyle.logoPosition || 'top'}
        showUserProfile={finalStyle.showUserProfile !== false}
        userProfilePosition={finalStyle.userProfilePosition || 'bottom'}
        onMenuItemPress={handleMenuItemPress}
        {...canvasRestProps}
      />
    );
  }

  const screenType = getScreenTypeFromId(props.id);
  const breakpointIndex = props.id?.endsWith('.0')
    ? 0
    : props.id?.endsWith('.1')
    ? 1
    : 2;
  const screenDimensions = getComponentScreenDimensions(
    SideBarConfig,
    breakpointIndex
  );

  const { finalStyle } = processStyles({
    attributes: props.attributes,
    style: props.style,
    config: SideBarConfig,
    libraryComponentManifest: props.libraryComponentManifest,
    ...props,
  });

  const effectiveWidth = parseDimension(screenDimensions.width);
  let heightValue =
    finalStyle.height || props.height || screenDimensions.height;
  // In preview mode, prioritize percentage values from finalStyle.height
  if (
    typeof finalStyle.height === 'string' &&
    finalStyle.height.includes('%')
  ) {
    heightValue = finalStyle.height;
  }
  const effectiveHeight = parseDimension(heightValue);

  const containerStyle = {
    backgroundColor: finalStyle.backgroundColor || '#2c3e50',
    width: effectiveWidth,
    height: effectiveHeight,
    zIndex: finalStyle.zIndex || 1000,
  };

  const {
    backgroundColor: _bg,
    textColor: _tc,
    activeColor: _ac,
    hoverColor: _hc,
    activeOpacity: _ao,
    layoutMode: _lm,
    collapsible: _c,
    collapsed: _col,
    position: _p,
    showLogo: _sl,
    logoPosition: _lp,
    showUserProfile: _sup,
    userProfilePosition: _upp,
    attributes: _attr,
    containerStyle: _cs,
    isCanvasMode: _icm,
    ...restProps
  } = props;

  return (
    <SideBarLayout
      {...restProps}
      attributes={props.attributes || {}}
      containerStyle={containerStyle}
      screenType={screenType}
      screenSize={{ width: effectiveWidth, height: effectiveHeight }}
      width={effectiveWidth}
      height={effectiveHeight}
      isCanvasMode={false}
      onMenuItemPress={handleMenuItemPress}
      backgroundColor={finalStyle.backgroundColor || '#2c3e50'}
      textColor={finalStyle.color || '#ffffff'}
      activeColor={finalStyle.activeColor || '#3498db'}
      hoverColor={finalStyle.hoverColor || '#34495e'}
      activeOpacity={finalStyle.activeOpacity || 0.3}
      layoutMode={finalStyle.layoutMode || 'push'}
      collapsible={finalStyle.collapsible !== false}
      collapsed={finalStyle.collapsed || false}
      position={finalStyle.position || 'left'}
      showLogo={finalStyle.showLogo !== false}
      logoPosition={finalStyle.logoPosition || 'top'}
      showUserProfile={finalStyle.showUserProfile !== false}
      userProfilePosition={finalStyle.userProfilePosition || 'bottom'}
      fontFamily={finalStyle.fontFamily}
      userName={get(bindingValue, 'userLogin.userName', '')}
      userEmail={get(bindingValue, 'userLogin.userEmail', '')}
    />
  );
}
